import React, { useEffect, useState } from 'react';

import { HARDWARE_ACCELERATION_POPUP_STRINGS } from 'src/utils/constants/stringConstants';

import { CHROME_VERSION_POPUP_ASSETS } from '../../utils/constants/ConsumptionPagesConstants';
import * as customStyled from './styles';
import { mixpanelObject } from '../../utils/analytics';
import {
  MIXPANEL_BROWSER_HARDWARE_ACCELERATION_POPUP,
  MIXPANEL_MANDATORY,
  MIXPANEL_NATIVE,
  MIXPANEL_POP_UP_GROUP,
  MIXPANEL_POP_UP_NAME,
  MIXPANEL_POP_UP_TYPE
} from '../../utils/analytics/mixpanel/mixpanelConstants';
import { popupLaunchEvent } from '../../utils/analytics/mixpanel/mixpanelEventsHelper';

interface HardwareAccelerationPopupProps {
  checkHardwareAccelerationPopup: (param: boolean) => void;
}

const HardwareAccelerationPopup: React.FC<HardwareAccelerationPopupProps> = ({
  checkHardwareAccelerationPopup
}) => {
  const [popupFlag, setPopUpState] = useState<boolean>(false);

  const isChromeBrowser = (): boolean => {
    const userAgent = navigator.userAgent;
    const isChrome =
      userAgent.includes('Chrome') &&
      !userAgent.includes('Edg') &&
      !userAgent.includes('OPR');
    return isChrome;
  };

  const isHardwareAccelerationEnabled = (): boolean => {
    // create a test function for both "default" drawing and forced software
    const test = (force = false) => {
      const canvas = document.createElement('canvas');
      // willReadFrequently will force software rendering
      const ctx: any = canvas.getContext('2d', { willReadFrequently: force });
      ctx.moveTo(0, 0), ctx.lineTo(120, 121); // HWA is bad at obliques
      ctx.stroke();
      return ctx.getImageData(0, 0, 200, 200).data.join();
    };
    // check that both return different results
    return test(true) !== test(false);
  };

  useEffect(() => {
    const isChrome = isChromeBrowser();
    const hardwareAccelerationEnabled = isHardwareAccelerationEnabled();
    if (isChrome) {
      checkHardwareAccelerationPopup(!hardwareAccelerationEnabled);
      setPopUpState(!hardwareAccelerationEnabled);
      if (!hardwareAccelerationEnabled) {
        popUpLaunch();
      }
    }
  }, []);

  const popUpLaunch = () => {
    mixpanelObject[MIXPANEL_POP_UP_NAME] =
      MIXPANEL_BROWSER_HARDWARE_ACCELERATION_POPUP;
    mixpanelObject[MIXPANEL_POP_UP_GROUP] = MIXPANEL_MANDATORY;
    mixpanelObject[MIXPANEL_POP_UP_TYPE] = MIXPANEL_NATIVE;
    popupLaunchEvent();
  };

  const closePopUp = () => {
    window.history.back();
  };

  return (
    <React.Fragment>
      {popupFlag && (
        <div css={customStyled.popupScreen}>
          <div css={customStyled.popupPlacer}>
            <React.Fragment>
              <div css={customStyled.popupWrapper} id="chrome_popup">
                <div css={customStyled.closeIconWrapper}>
                  <div onClick={closePopUp}>
                    <img
                      css={customStyled.closeIconImage}
                      src={CHROME_VERSION_POPUP_ASSETS.CLOSE_ICON}
                      alt="closeIcon"
                    />
                  </div>
                </div>
                <div css={customStyled.title}>
                  {HARDWARE_ACCELERATION_POPUP_STRINGS.title}
                </div>
                <div css={customStyled.desc}>
                  {HARDWARE_ACCELERATION_POPUP_STRINGS.description}
                </div>
              </div>
            </React.Fragment>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default HardwareAccelerationPopup;
